import { render } from "./Mine.vue?vue&type=template&id=4053c9dd"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\项目\\点餐小程序\\ec-food-cardholder-t1-frontend-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__